import { render, staticRenderFns } from "./MusicAuthDetailItem.vue?vue&type=template&id=14456fbd&scoped=true&"
import script from "./MusicAuthDetailItem.vue?vue&type=script&lang=js&"
export * from "./MusicAuthDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./MusicAuthDetailItem.vue?vue&type=style&index=0&id=14456fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14456fbd",
  null
  
)

export default component.exports